<script lang="ts" setup>
import { ref } from 'vue';

const props = defineProps<{ tool: 'sex-pose' | 'ai-video' | 'face-swap' }>();

const auth = useAuthStore();
const router = useRouter();
const localePath = useLocalePath();

const dragOver = ref(false);

function gotoLogin() {
  const target = `/editor?type=${props.tool}`;
  router.push(localePath(`/login/google?redirect=${encodeURIComponent(target)}`));
}

function gotoEditor() {
  router.push({ path: localePath('/editor'), query: { type: props.tool } });
}

function onUploadClick() {
  if (!auth.isLogin) { gotoLogin(); return; }
  gotoEditor();
}

function onDrop(event: DragEvent) {
  event.preventDefault();
  dragOver.value = false;
  if (!auth.isLogin) { gotoLogin(); return; }
  gotoEditor();
}
</script>

<template>
  <div
    class="zone"
    :class="{ 'drag-over': dragOver }"
    @dragover.prevent="dragOver = true"
    @dragleave="dragOver = false"
    @drop="onDrop"
  >
    <h3 class="grad">Drag and drop your image</h3>
    <p class="sub">into this area to get started</p>

    <button class="upload-btn" @click="onUploadClick">Upload a Photo</button>

    <p class="formats">Supported formats: JPG, PNG, WEBP</p>
  </div>
</template>

<style scoped lang="scss">
.zone {
  @apply rounded-2xl border-2 border-dashed border-amber-500/40 bg-neutral-950/60
         px-6 py-10 text-center;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  &.drag-over { @apply border-amber-500 bg-amber-500/5; }
}
.grad {
  @apply text-2xl md:text-3xl font-bold;
  background: linear-gradient(135deg, #f97316 0%, #fbbf24 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.sub { @apply text-white/70; }
.upload-btn {
  @apply inline-flex items-center justify-center rounded-full px-10 py-4 mt-4 font-semibold text-white cursor-pointer transition-all;
  background: linear-gradient(135deg, #f97316 0%, #ea580c 50%, #c2410c 100%);
  box-shadow: 0 8px 24px -8px rgba(249,115,22,0.5);
  &:hover { transform: scale(1.03); }
}
.formats { @apply mt-3 text-xs text-white/40; }
</style>
